import "./polyfill/number-is-nan";

import "bootstrap-sass";
import "jquery-match-height";

import "./modules/webfont";
import "./modules/page-top";
// import "./modules/jqueryvalidation";
import "./modules/menu-trigger";
// import "./modules/bs.tab";
import "./modules/js-header";
// import "./modules/js-footer";
// import "./modules/waypoints";
import "./modules/dropdown-hover";
import "./modules/swiper-fv";
import "./modules/aos";
import "./modules/jquery-match-height";
import "./modules/modal";
// import "./modules/grBackToTop";
// import ScrollMagic from "scrollmagic";
// import "./modules/parallax";
import "./modules/luxy";
import "./modules/form";
import "./modules/countdown";
import "./modules/fv";
import "./modules/typing";
import "./modules/loader";
